<!-- Toast.vue -->
<template>
    <transition name="fade">
        <div v-if="visible" class="toast">
            {{ message }}
        </div>
    </transition>
</template>

<script>
export default {
    name: 'Toast',
    data() {
        return {
            visible: false,
            message: ''
        }
    },
    methods: {
        show(msg, duration = 2000) {
            this.message = msg
            this.visible = true
            setTimeout(() => {
                this.visible = false
            }, duration)
        }
    }
}
</script>

<style scoped>
.toast {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.75);
    color: #fff;
    padding: 10px 20px;
    border-radius: 8px;
    font-size: 14px;
    z-index: 9999;
    white-space: nowrap;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>